export const getRequiredAge = async (minRequiredAge) => {
  if (minRequiredAge.value === '21' || minRequiredAge.value === 'age21') {
    return 21;
  }
  if (minRequiredAge.value === '18' || minRequiredAge.value === 'age18') {
    return 18;
  }
  return 0;
};
